import React from "react";
import {
  AiOutlineClose,
  AiOutlineCalendar,
  AiOutlineClockCircle,
  AiOutlineMessage,
  AiOutlinePhone,
} from "react-icons/ai";

const CallDetails = ({ item, closePopup }) => {
  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg w-full sm:w-96 p-4 mt-16 relative">
        {" "}
        {/* Add mt-16 to create space from the top */}
        {/* Close Button */}
        <div className="flex justify-end">
          <AiOutlineClose
            className="text-gray-500 cursor-pointer absolute right-0 top-0"
            size={24}
            onClick={closePopup}
          />
        </div>
        {/* Heading */}
        <p className="text-xl font-semibold text-gray-600 mb-4">
          Call with {item?.user_name}
        </p>
        <hr className="border-t border-gray-300 mb-4" />
        {/* For Section */}
        <div className="flex justify-between items-center mb-4">
          <p className="text-gray-700">
            <b>For :</b> {item?.session_title}
          </p>
          <div className="text-green-800 bg-green-100 rounded-full px-3 py-1 text-xl">
            {item?.status}
          </div>
        </div>
        {/* Price Breakdown Section */}
        <div className="border rounded-md mb-4 p-1 py-3">
          <div className="flex items-center justify-between">
            {/* First Column */}
            <div className="flex items-center mb-2">
              <AiOutlineCalendar size={25} className="mr-2" />
              <h4 className="text-md font-bold text-gray-500">
                {item?.day} {item?.scheduledOn}
              </h4>
            </div>

            {/* Second Column */}
            <div className="flex items-center">
              <AiOutlineClockCircle size={25} className="mr-2" />
              <p className="text-sm text-gray-500 font-semibold">
                {item?.time}({item?.duration} mins)
              </p>
            </div>
          </div>
        </div>
        {/* Attendee Details Section */}
        <div className="mb-4">
          <p className="text-2xl text-gray-600 font-bold mb-2">
            Attendee details:
          </p>
          <div className="flex justify-between items-center mb-2 border rounded-md p-1 py-3">
            {/* First Column */}
            <div className="flex items-center">
              <AiOutlineMessage size={20} className="mr-2" />
              <p className="text-sm">{item?.user_email}</p>
            </div>

            {/* Second Column */}
            <div className="flex items-center">
              <AiOutlinePhone size={20} className="lg:mr-2" />
              <p className="text-sm">{item?.user_phone}</p>
            </div>
          </div>
        </div>
        {/* What is call about Section */}
        <div className="mb-4">
          <p className="text-gray-600 mb-2 font-bold">
            What is the call about?
          </p>
          <p className="text-sm text-gray-500 font-semibold">
            {item?.session_title}
          </p>
        </div>
        {/* Price Breakdown Section */}
        <div className="bg-gray-100 p-2 rounded-md">
          <p className="text-gray-700 mb-2 font-bold">Price Breakdown</p>
          <div className="flex justify-between items-center mb-2">
            <p className="text-sm text-gray-500 font-semibold">Base Price</p>
            <p className="text-sm text-gray-500 font-semibold">
              ₹ {item?.amount?.service_amount || 0}
            </p>
          </div>
          <hr className="border-t border-gray-300 mb-2" />
          <div className="flex justify-between items-center">
            <p className="text-sm font-semibold">Total</p>
            <p className="text-sm font-semibold">
              ₹ {item?.amount?.service_amount || 0}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallDetails;
